import { h, createRef } from 'preact';
import register from '@wcd/preact-custom-element';
import { useEffect } from 'preact/hooks';
import { Tabs } from '../../../types/web-components';

export const component: Tabs = ({ children }) => {
  const ref: any = createRef();

  useEffect(() => {
    const tabs = ref.current.querySelectorAll('.rdp-tabs__trigger');
    const scroller = ref.current.querySelector('.rdp-tabs__panels-scroller');
    const indicator = ref.current.querySelector('.rdp-tabs__current_indicator');

    const hideScroller = ({ target }) => {
      if (target === scroller) {
        const styles = indicator.getAttribute('style');
        indicator.setAttribute('style', `${styles} width: 1%; left: 1px;`);
      }
    };

    scroller.addEventListener('transitionend', hideScroller);

    const activate = (tab, index) => {
      const previouslySelectedPanel = ref.current.querySelector('.active-panel');
      const previouslySelectedTab = ref.current.querySelector('.active-tab');
      previouslySelectedTab.classList.remove('active-tab');
      previouslySelectedPanel.classList.remove('active-panel');
      previouslySelectedPanel.setAttribute('style', `transform: translate3d(0%, 0px, 0px); height: 0`);
      previouslySelectedPanel.setAttribute('tabindex', '-1');
      tab.removeAttribute('tabindex');
      tab.setAttribute('aria-selected', 'true');

      const panelId = tab.getAttribute('aria-controls');
      const panel = ref.current.querySelector(`[id="${panelId}"]`);
      tab.classList.add('active-tab');
      panel.classList.add('active-panel');
      panel.setAttribute('style', `transform: translate3d(${index * 100}%, 0, 0); height: auto`);
      scroller.setAttribute('style', `transform: translate3d(-${index * 100}%, 0, 0);`);
      indicator.setAttribute('style', `transform: translate3d(${tab.offsetLeft}px, 0, 0); width: ${tab.offsetWidth}px;`);
    };

    for (let i = 0; i < tabs.length; ++i) {
      tabs[i].addEventListener('click', (event) => {
        activate(event.target, i);
      });
    }

    return () => {
      for (const tab of tabs) {
        tab.removeEventListener('click', activate);
      }
      scroller.removeEventListener('transitionend', hideScroller);
    };
  });

  return <div ref={ref}>{children}</div>;
};
register(component, 'tes-tabs', [], { shadow: false });
